Profile.$inject = ["$http", "$q", "$rootScope", "gplansConf", "$localStorage"]; /**
                                                                                * Profile
                                                                                * @namespace gplans.profiles.services
                                                                                */

/**
                                                                                    * @namespace Profile
                                                                                    */
// $analytics
export function Profile($http, $q, $rootScope, gplansConf, $localStorage) {
  "ngInject";
  /**
               * @name Profile
               * @desc The factory to be returned
               * @memberOf gplans.profiles.services.Profile
               */
  var Profile = {
    destroy: destroy,
    get: get,
    getMyMealplan: getMyMealplan,
    createSwap: createSwap,
    getFoods: getFoods,
    createCheckin: createCheckin,
    getCheckins: getCheckins,
    getCheckin: getCheckin,
    updateCheckin: updateCheckin,
    createMisc: createMisc,
    getMisc: getMisc,
    updateMisc: updateMisc,
    getWeeklyCoaching: getWeeklyCoaching,
    getWeeklyCoachingAll: getWeeklyCoachingAll,
    createLoggedMeal: createLoggedMeal,
    destroyLoggedMeal: destroyLoggedMeal,
    createLoggedMealItem: createLoggedMealItem,
    destroyLoggedMealItem: destroyLoggedMealItem,
    getAchievements: getAchievements,
    getWaterTrackers: getWaterTrackers,
    createWaterTracker: createWaterTracker,
    updateWaterTracker: updateWaterTracker,
    getExerciseTrackers: getExerciseTrackers,
    createExerciseTracker: createExerciseTracker,
    updateExerciseTracker: updateExerciseTracker,
    createCustomer: createCustomer,
    createOrder: createOrder,
    update: update,
    sendGroceriesListEmail: sendGroceriesListEmail,
    purchaseUpsell: purchaseUpsell,
    purchaseUpsellBundle: purchaseUpsellBundle,
    purchaseUpsellDown: purchaseUpsellDown,
    getExercises: getExercises,
    createLoggedExercise: createLoggedExercise,
    destroyLoggedExercise: destroyLoggedExercise,
    destroyMealItem: destroyMealItem,
    addMealItem: addMealItem,
    updateMealItem: updateMealItem,
    getFoodsForAutocomplete: getFoodsForAutocomplete,
    getFreeFoods: getFreeFoods,
    purchaseUpsellNutritionist: purchaseUpsellNutritionist,
    purchaseDownsellNutritionist: purchaseDownsellNutritionist,
    getTimeslots: getTimeslots,
    createSetmoreCustomer: createSetmoreCustomer,
    createSetmoreAppointment: createSetmoreAppointment,
    purchaseDownsellNutritionistTestNewPrice: purchaseDownsellNutritionistTestNewPrice };


  return Profile;

  /////////////////////

  /**
   * @name destroy
   * @desc Destroys the given profile
   * @param {Object} profile The profile to be destroyed
   * @returns {Promise}
   * @memberOf gplans.profiles.services.Profile
   */
  function destroy(profile) {
    return $http.delete(gplansConf.API_URL + '/api/v1/accounts/' + profile.id + '/');
  }

  /**
     * @name getMyMealplan
     * @desc Fetches current user's Meals by week / day
     * @param {Object} profile The profile that owns the MealPlan
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function getMyMealplan(oFilters) {
    return $http.get(gplansConf.API_URL + '/api/v2/new-mymealplan/', { params: oFilters });
  }

  /**
     * @name getAchievements
     * @desc Fetches the given profile's current Achievement object list
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function getAchievements() {
    $rootScope.suppressLoader = 1;
    return $http.get(gplansConf.API_URL + '/api/v1/achievements/').
    then(
    function (res) {
      $rootScope.suppressLoader = 0;
      return res;
    },
    function (data) {
      $rootScope.suppressLoader = 0;
      return $q.reject(data);
    });
  }

  /**
     * @name getFoods
     * @desc Fetches the given profile's current Food object list
     * @param {Object} filters for week_number and meal_number
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function getFoods(oFilters) {
    $rootScope.suppressLoader = 1;
    return $http.get(gplansConf.API_URL + '/api/v1/foods/', { params: oFilters }).
    then(
    function (res) {
      $rootScope.suppressLoader = 0;
      return res;
    },
    function (data) {
      $rootScope.suppressLoader = 0;
      return $q.reject(data);
    });
    return req;
  }

  /**
     * @name createSwap
     * @desc Creates a Swap object for the current user
     * @param {Object} Swap {replace: <id>, replace_with: <id>}
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function createSwap(oSwap) {
    $analytics.eventTrack('Swap Meal Item');
    $rootScope.suppressLoader = 1;
    return $http.post(gplansConf.API_URL + '/api/v1/swaps/', oSwap).
    then(
    function (res) {
      $rootScope.suppressLoader = 0;
      return res;
    },
    function (data) {
      $rootScope.suppressLoader = 0;
      return $q.reject(data);
    });
  }


  /**
     * @name createCustomer
     * @desc Creates a Customer object for the current user
     * @param {Object} Customer
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function createCustomer(oCustomer) {
    return $http.post(gplansConf.API_URL + '/api/v1/customers/', oCustomer);
  }

  /**
     * @name createOrder
     * @desc Creates a Order object for the current user
     * @param {Object} Order
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function createOrder(oOrder) {
    return $http.post(gplansConf.API_URL + '/api/v1/customers/' + oOrder.customer + '/orders/', oOrder);
  }

  /**
     * @name createCheckin
     * @desc Creates a Checkin object for the current user
     * @param {Object} Checkin {weigth: <int>, prior_week_success: <bool>}
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function createCheckin(oCheckin) {
    return $http.post(gplansConf.API_URL + '/api/v1/checkins/', oCheckin);
  }

  /**
     * @name updateCheckin
     * @desc Updates a Checkin object for the current user
     * @param {Object} Checkin {weigth: <int>, prior_week_success: <bool>}
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function updateCheckin(oCheckin) {
    return $http.put(gplansConf.API_URL + '/api/v1/checkins/' + oCheckin.id + '/', oCheckin);
  }

  /**
     * @name getCheckin
     * @desc Fetches a single Checkin object for the current user
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function getCheckin(checkinId) {
    return $http.get(gplansConf.API_URL + '/api/v1/checkins/' + checkinId + '/');
  }


  /**
     * @name getCheckins
     * @desc Fetches the Checkin objects for the current user
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function getCheckins() {
    $rootScope.suppressLoader = 1;
    return $http.get(gplansConf.API_URL + '/api/v1/checkins/').
    then(
    function (res) {
      $rootScope.suppressLoader = 0;
      return res;
    },
    function (data) {
      $rootScope.suppressLoader = 0;
      return $q.reject(data);
    });
  }

  /**
     * @name getWaterTrackers
     * @desc Fetches the given profile's current WaterTracker object list
     * @param {Object} filters for week, day
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function getWaterTrackers(oFilters) {
    $rootScope.suppressLoader = 1;
    return $http.get(gplansConf.API_URL + '/api/v1/watertrackers/', { params: oFilters }).
    then(
    function (res) {
      $rootScope.suppressLoader = 0;
      return res;
    },
    function (data) {
      $rootScope.suppressLoader = 0;
      return $q.reject(data);
    });
  }

  /**
     * @name updateWaterTracker
     * @desc Update the given profile's water trackers
     * @param {Object} the WaterTracker
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function updateWaterTracker(oWaterTracker) {
    $rootScope.suppressLoader = 1;
    return $http.put(gplansConf.API_URL + '/api/v1/watertrackers/' + oWaterTracker.id + '/', oWaterTracker).
    then(
    function (res) {
      $rootScope.suppressLoader = 0;
      return res;
    },
    function (data) {
      $rootScope.suppressLoader = 0;
      return $q.reject(data);
    });
  }

  /**
     * @name createWaterTracker
     * @desc Creates a WaterTracker object for the current user
     * @param {Object} WaterTracker {meal: <id>}
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function createWaterTracker(oWaterTracker) {
    $rootScope.suppressLoader = 1;
    return $http.post(gplansConf.API_URL + '/api/v1/watertrackers/', oWaterTracker).
    then(
    function (res) {
      $rootScope.suppressLoader = 0;
      return res;
    },
    function (data) {
      $rootScope.suppressLoader = 0;
      return $q.reject(data);
    });
  }

  /**
     * @name getExerciseTrackers
     * @desc Fetches the given profile's current ExerciseTracker object list
     * @param {Object} filters for week, day
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function getExerciseTrackers(oFilters) {
    $rootScope.suppressLoader = 1;
    return $http.get(gplansConf.API_URL + '/api/v1/exercisetrackers/', { params: oFilters }).
    then(
    function (res) {
      $rootScope.suppressLoader = 0;
      return res;
    },
    function (data) {
      $rootScope.suppressLoader = 0;
      return $q.reject(data);
    });
  }

  /**
     * @name updateExerciseTracker
     * @desc Update the given profile's exercise trackers
     * @param {Object} the ExerciseTracker
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function updateExerciseTracker(oExerciseTracker) {
    $rootScope.suppressLoader = 1;
    return $http.put(gplansConf.API_URL + '/api/v1/exercisetrackers/' + oExerciseTracker.id + '/', oExerciseTracker).
    then(
    function (res) {
      $rootScope.suppressLoader = 0;
      return res;
    },
    function (data) {
      $rootScope.suppressLoader = 0;
      return $q.reject(data);
    });
  }

  /**
     * @name createExerciseTracker
     * @desc Creates a ExerciseTracker object for the current user
     * @param {Object} ExerciseTracker {meal: <id>}
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function createExerciseTracker(oExerciseTracker) {
    $rootScope.suppressLoader = 1;
    return $http.post(gplansConf.API_URL + '/api/v1/exercisetrackers/', oExerciseTracker).
    then(
    function (res) {
      $rootScope.suppressLoader = 0;
      return res;
    },
    function (data) {
      $rootScope.suppressLoader = 0;
      return $q.reject(data);
    });
  }

  function getExercises() {
    $rootScope.suppressLoader = 1;
    return $http.get(gplansConf.API_URL + '/api/v1/exercise/').
    then(
    function (res) {
      $rootScope.suppressLoader = 0;
      return res;
    },
    function (data) {
      $rootScope.suppressLoader = 0;
      return $q.reject(data);
    });
  }

  function createLoggedExercise(oLoggedExercise) {
    $rootScope.suppressLoader = 1;
    return $http.post(gplansConf.API_URL + '/api/v1/loggedexercise/', oLoggedExercise).
    then(
    function (res) {
      $rootScope.suppressLoader = 0;
      return res;
    },
    function (data) {
      $rootScope.suppressLoader = 0;
      return $q.reject(data);
    });
  }

  function destroyLoggedExercise(oLoggedExercise) {
    $rootScope.suppressLoader = 1;
    return $http.delete(gplansConf.API_URL + '/api/v1/loggedexercise/' + oLoggedExercise.id + '/').
    then(
    function (res) {
      $rootScope.suppressLoader = 0;
      return res;
    },
    function (data) {
      $rootScope.suppressLoader = 0;
      return $q.reject(data);
    });
  }

  /**
     * @name createLoggedMeal
     * @desc Creates a LoggedMeal object for the current user
     * @param {Object} LoggedMeal {meal: <id>}
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function createLoggedMeal(oLoggedMeal) {
    $analytics.eventTrack('Log Meal');
    $rootScope.suppressLoader = 1;
    return $http.post(gplansConf.API_URL + '/api/v2/loggedmeals/', oLoggedMeal).
    then(
    function (res) {
      $rootScope.suppressLoader = 0;
      return res;
    },
    function (data) {
      $rootScope.suppressLoader = 0;
      return $q.reject(data);
    });
  }

  /**
     * @name destroyLoggedMeal
     * @desc Destroys a LoggedMeal object for the current user
     * @param {Object} LoggedMeal {meal: <id>}
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function destroyLoggedMeal(oLoggedMeal) {
    $rootScope.suppressLoader = 1;
    var oFilters = {
      logged_meal__meal_id: oLoggedMeal.id };

    return $http.delete(gplansConf.API_URL + '/api/v2/loggedmeals/' + oLoggedMeal.logged_meal_id + '/', { params: oFilters }).
    then(
    function (res) {
      $rootScope.suppressLoader = 0;
      return res;
    },
    function (data) {
      $rootScope.suppressLoader = 0;
      return $q.reject(data);
    });
  }

  /**
     * @name createLoggedMealItem
     * @desc Creates a LoggedMealItem object for the current user
     * @param {Object} LoggedMealItem {logged_meal: <id>}
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function createLoggedMealItem(oLoggedMealItem) {
    $rootScope.suppressLoader = 1;
    return $http.post(gplansConf.API_URL + '/api/v2/loggedmealitems/', oLoggedMealItem).
    then(
    function (res) {
      $rootScope.suppressLoader = 0;
      return res;
    },
    function (data) {
      $rootScope.suppressLoader = 0;
      return $q.reject(data);
    });
  }

  /**
     * @name destroyLoggedMealItem
     * @desc Destroys a LoggedMealItem object for the current user
     * @param {Object} LoggedMealItem {logged_meal: <id>}
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function destroyLoggedMealItem(oLoggedMealItem) {
    $rootScope.suppressLoader = 1;
    return $http.delete(gplansConf.API_URL + '/api/v2/loggedmealitems/' + oLoggedMealItem.id + '/').
    then(
    function (res) {
      $rootScope.suppressLoader = 0;
      return res;
    },
    function (data) {
      $rootScope.suppressLoader = 0;
      return $q.reject(data);
    });
  }

  /**
     * @name createMisc
     * @desc Creates a Misc object for the current user
     * @param {Object} Misc {key: <string>, value: <string>}
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function createMisc(oMisc) {
    $rootScope.suppressLoader = 1;
    return $http.post(gplansConf.API_URL + '/api/v2/misc/', oMisc).
    then(
    function (res) {
      $rootScope.suppressLoader = 0;
      return res;
    },
    function (data) {
      $rootScope.suppressLoader = 0;
      return $q.reject(data);
    });
  }

  /**
     * @name updateMisc
     * @desc Updates a Misc object for the current user by its key
     * @param {Object} Misc {key: <string>, value: <string>}
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function updateMisc(oMisc) {
    return $http.put(gplansConf.API_URL + '/api/v2/misc/' + oMisc.key + '/', oMisc);
  }

  /**
     * @name getMisc
     * @desc Fetches a single Misc object for the current user by its key
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function getMisc(miscKey) {
    return $http.get(gplansConf.API_URL + '/api/v2/misc/' + miscKey + '/');
  }

  /**
     * @name getWeeklyCoaching
     * @desc Fetches Weekly Coaching tips for the current user by week number
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function getWeeklyCoaching(week) {
    return $http.get(gplansConf.API_URL + '/api/v1/coaching/' + week + '/');
  }

  /**
     * @name getWeeklyCoachingAll
     * @desc Fetches All Weekly Coaching tips for the current user
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function getWeeklyCoachingAll() {
    return $http.get(gplansConf.API_URL + '/api/v1/coaching/');
  }

  /**
     * @name get
     * @desc Gets the profile for user with username `username`
     * @param {string} username The username of the user to fetch
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function get(username) {
    return $http.get(gplansConf.API_URL + '/api/v1/accounts/' + username + '/');
  }


  /**
     * @name update
     * @desc Update the given profile
     * @param {Object} profile The profile to be updated
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function update(profile, origUsername) {
    return $http.put(gplansConf.API_URL + '/api/v1/accounts/' + (origUsername || profile.username) + '/', profile).
    then(
    function (res) {
      $rootScope.suppressLoader = 0;
      return res;
    },
    function (data) {
      $rootScope.suppressLoader = 0;
      return $q.reject(data);
    });
  }

  /**
     * @name sendGroceriesListEmail
     * @desc Send Groceries List for current week to current user
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function sendGroceriesListEmail(oWeekNumber) {
    return $http.get(gplansConf.API_URL + '/api/v1/accounts/send-groceries-list-email/', { params: oWeekNumber });
  }

  /**
     * @name purchaseUpsell
     * @desc purchases upsell (TODO: make it able to purchase different ones)
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function purchaseUpsell() {
    // return $http.post(gplansConf.API_URL+'/api/v1/upsell/', {token: token}, {});

    //TODO: rebuild this...
    return $http({
      method: 'POST',
      url: gplansConf.API_URL + '/api/v1/upsell/',
      headers: {
        'Authorization': 'Token ' + $localStorage['authToken'],
        'Content-Type': 'application/json' } });


  }

  /**
     * @name destroyMealItem
     * @desc Destroys a MealItem object for the current user
     * @param {Object} oMealItem {meal: <id>}
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function destroyMealItem(oMealItem) {
    $rootScope.suppressLoader = 1;
    return $http.delete(gplansConf.API_URL + '/api/v2/usermealitems/' + oMealItem.id + '/').
    then(
    function (res) {
      $rootScope.suppressLoader = 0;
      return res;
    },
    function (data) {
      $rootScope.suppressLoader = 0;
      return $q.reject(data);
    });
  }

  /**
     * @name addMealItem
     * @desc Creates a Meal object for the current user
     * @param {Object} Meal {}
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function addMealItem(oMealItem) {
    $rootScope.suppressLoader = 1;
    return $http.post(gplansConf.API_URL + '/api/v2/usermealitems/', oMealItem).
    then(
    function (res) {
      $rootScope.suppressLoader = 0;
      return res;
    },
    function (data) {
      $rootScope.suppressLoader = 0;
      return $q.reject(data);
    });
  }


  /**
     * @name updateMealItem
     * @desc Update a Meal object for the current user (create Swap)
     * @param {Object} Meal {}
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function updateMealItem(oMealItem) {
    $rootScope.suppressLoader = 1;
    return $http.put(gplansConf.API_URL + '/api/v2/usermealitems/' + oMealItem.id + '/', oMealItem).
    then(
    function (res) {
      $rootScope.suppressLoader = 0;
      return res;
    },
    function (data) {
      $rootScope.suppressLoader = 0;
      return $q.reject(data);
    });
  }


  /**
     * @name purchaseUpsellBundle
     * @desc purchases upsell bundle
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function purchaseUpsellBundle(paypalSubscriptionPaymentToken) {
    return $http({
      method: 'POST',
      url: gplansConf.API_URL + '/api/v1/upsell-bundle/',
      headers: {
        'Authorization': 'Token ' + $localStorage['authToken'],
        'Content-Type': 'application/json' },

      data: {
        paypal_payment_token: paypalSubscriptionPaymentToken } });


  }

  /**
     * @name purchaseUpsellDown
     * @desc purchases downsell
     * @returns {Promise}
     * @memberOf gplans.profiles.services.Profile
     */
  function purchaseUpsellDown() {
    return $http({
      method: 'POST',
      url: gplansConf.API_URL + '/api/v1/upsell-down/',
      headers: {
        'Authorization': 'Token ' + $localStorage['authToken'],
        'Content-Type': 'application/json' } });


  }
  function getFoodsForAutocomplete(q) {
    $rootScope.suppressLoader = 1;
    return $http.get(gplansConf.API_URL + '/api/v1/search-food/', { params: q }).
    then(
    function (res) {
      $rootScope.suppressLoader = 0;
      return res;
    },
    function (data) {
      $rootScope.suppressLoader = 0;
      return $q.reject(data);
    });
  }

  function getFreeFoods() {
    return $http.get(gplansConf.API_URL + '/api/v1/freefoods/').
    then(
    function (res) {
      return res;
    },
    function (data) {
      return $q.reject(data);
    });
    return req;
  }

  function addExtraMealItem(oMealItem, day_number, week_number) {
    var get_params = { week_number: week_number, day_number: day_number };
    $rootScope.suppressLoader = 1;
    return $http.post(gplansConf.API_URL + '/api/v2/userextramealitems/', oMealItem, { params: get_params }).
    then(
    function (res) {
      $rootScope.suppressLoader = 0;
      return res;
    },
    function (data) {
      $rootScope.suppressLoader = 0;
      alert(data.data);
      return $q.reject(data);
    });
  }


  function purchaseUpsellNutritionist() {
    return $http({
      method: 'POST',
      url: gplansConf.API_URL + '/api/v1/upsell-nutritionist/',
      headers: {
        'Authorization': 'Token ' + $localStorage['authToken'],
        'Content-Type': 'application/json' } });


  }

  function purchaseDownsellNutritionist(params) {
    return $http({
      method: 'POST',
      url: gplansConf.API_URL + '/api/v1/upsell-down-nutritionist/',
      headers: {
        'Authorization': 'Token ' + $localStorage['authToken'],
        'Content-Type': 'application/json' },

      params: params });

  }

  function getTimeslots(date) {var from_tips = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var params = { date: date, from_tips: from_tips };
    var headers = {
      'Authorization': 'Token ' + $localStorage['authToken'],
      'Content-Type': 'application/json' };

    return $http.get(gplansConf.API_URL + '/api/v1/nutritionists/timeslots/', { params: params }, headers);
  }

  function createSetmoreCustomer(user) {
    var headers = {
      'Authorization': 'Token ' + $localStorage['authToken'],
      'Content-Type': 'application/json' };

    return $http.get(gplansConf.API_URL + '/api/v1/nutritionists/create-setmore-customer/', { params: user }, headers);
  }

  function createSetmoreAppointment(appointment) {
    var headers = {
      'Authorization': 'Token ' + $localStorage['authToken'],
      'Content-Type': 'application/json' };

    return $http.get(gplansConf.API_URL + '/api/v1/nutritionists/create-setmore-appointment/', { params: appointment }, headers);
  }

  function purchaseDownsellNutritionistTestNewPrice() {
    return $http({
      method: 'POST',
      url: gplansConf.API_URL + '/api/v1/upsell-down-nutritionist-other/',
      headers: {
        'Authorization': 'Token ' + $localStorage['authToken'],
        'Content-Type': 'application/json' } });


  }

}